/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobResultOfBulkImportCustomerUsersResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type JobResultOfBulkImportCustomerUsersResponse } from '../../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users/customers/import/progress/{trackingId}
 */
export interface WithTrackingItemRequestBuilder extends BaseRequestBuilder<WithTrackingItemRequestBuilder> {
    /**
     * Reports a queued bulk customer-user import by its tracking id. While the import runs, currentStep counts processed rows out of totalSteps and currentStatus describes the running totals; result is null. When the import finishes, result carries the same per-row report the import previously returned inline, including any generated temporary passwords — collect it promptly, because the job and its report are deleted about a day after the import was queued. Poll on an interval of a few seconds; every response is a full snapshot, so a missed poll loses nothing.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobResultOfBulkImportCustomerUsersResponse>}
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobResultOfBulkImportCustomerUsersResponse | undefined>;
    /**
     * Reports a queued bulk customer-user import by its tracking id. While the import runs, currentStep counts processed rows out of totalSteps and currentStatus describes the running totals; result is null. When the import finishes, result carries the same per-row report the import previously returned inline, including any generated temporary passwords — collect it promptly, because the job and its report are deleted about a day after the import was queued. Poll on an interval of a few seconds; every response is a full snapshot, so a missed poll loses nothing.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithTrackingItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users/customers/import/progress/{trackingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTrackingItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithTrackingItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobResultOfBulkImportCustomerUsersResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
